import * as JSData from 'js-data'
import * as JSDataHttp from 'js-data-http'
import Q from 'q'

import Toastr from '@/components/Toastr'
import property from 'lodash/property'
import Vue from 'vue'
import {vdata} from '@citygro/vdata'
import pick from 'lodash/pick'

JSData.utils.Promise = Q

const Db = new JSData.DataStore()

Vue.use(vdata(Db))

const httpAdapter = new JSDataHttp.HttpAdapter({
  basePath: '/rest',
  deserialize: (config, response, opts) => {
    opts.originalResponse = response
    let data = response.data
    console.log('data', response.data)
    if (response.data && !response.id) {
      if (response.data.data && !response.data.id) {
        data = response.data.data
      } else if (response.data.items && !response.data.id) {
        data = response.data.items
      } else if (response.data.rows && !response.data.id) {
        data = response.data.rows
      }
    }
    return data
  }
})

httpAdapter.http.defaults.transformRequest.push((data, headers) => {
  if (headers && headers.common) {
    // headers.common['X-Portal-Version'] = '0.0.1'
    headers.common['Accept'] = 'application/json'
    if (window.localStorage.token) {
      headers.common['Authorization'] = 'Bearer ' + window.localStorage.token
    }
  }
  return data
})

Db.handleResponse = function (response) {
  return response
}

Db.handleError = function (error) {
  if (property('status')(error) + '' === '401') {
    let $Session = require('@/Session').default
    console.log('session', $Session)
    $Session.logout()
    return
  }
  console.log('handle error', error)
  Toastr.error(property('response.data')(error) || property('data')(error) || error.message, 'Error', {
    preventDuplicates: true
  })
  return error
}

httpAdapter.http.interceptors.response.use((response) => {
  return Db.handleResponse(response)
}, (error, err2) => {
  Db.handleError(error)
  throw error
})

Db.registerAdapter('http', httpAdapter, {
  default: true
})

const modelMap = {
  company: {},
  machine: {
    options: {
      serialize: function (a, b, c) {
        return pick(b, ['name', 'location'])
      }
    }
  },
  recordtype: {},
  report: {},
  text: {},
  testtype: {},
  unit: {},
  user: {
    options: {
      idAttribute: 'username',
      serialize: function (a, b, c) {
        return pick(b, ['username', 'plainPassword', 'firstname', 'lastname', 'cellnumber', 'company', 'textprovider', 'units', 'admin'])
      }
    }
  }
}

Object.keys(modelMap).forEach((modelName) => {
  const options = modelMap[modelName].options || {}
  if (!options.idAttribute) {
    options.idAttribute = 'id'
  }
  Db.defineMapper(modelMap[modelName].name || modelName, options)
})

window.Db = Db

export default Db



// WEBPACK FOOTER //
// ./src/Db.js